import { Component, input, output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { PageHeaderComponent, type BreadcrumbItem } from '../page-header/page-header.component';
import { ListViewTabsComponent, type ListViewTab } from '../list-view-tabs/list-view-tabs.component';
import { TPipe } from '../../pipes/t.pipe';

@Component({
  selector: 'app-list-header',
  standalone: true,
  imports: [
    LucideAngularModule,
    PageHeaderComponent,
    ListViewTabsComponent,
    TPipe,
  ],
  templateUrl: './list-header.component.html',
})
export class ListHeaderComponent {
  title = input.required<string>();
  subtitle = input.required<string>();
  breadcrumbs = input.required<BreadcrumbItem[]>();
  tabs = input.required<ListViewTab[]>();

  tabSelect = output<string>();

  onTabSelect(id: string): void {
    this.tabSelect.emit(id);
  }
}
